function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTpLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "985px",
    height: "85px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.956
    },
    fill: "#000000",
    d: "M -0.5,-0.5 C 26.1667,-0.5 52.8333,-0.5 79.5,-0.5C 79.665,2.8499 79.4983,6.18323 79,9.5C 78.5348,10.9308 77.7014,12.0975 76.5,13C 66.9138,14.4204 57.2471,14.9204 47.5,14.5C 47.3644,37.8425 47.6977,61.1758 48.5,84.5C 40.8333,84.5 33.1667,84.5 25.5,84.5C 24.7955,61.8426 24.2955,39.1759 24,16.5C 16.1058,14.5506 7.93916,13.884 -0.5,14.5C -0.5,9.5 -0.5,4.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.951
    },
    fill: "#000000",
    d: "M 141.5,-0.5 C 147.833,-0.5 154.167,-0.5 160.5,-0.5C 176.405,25.6399 192.572,51.6399 209,77.5C 210.202,79.6775 210.702,82.0108 210.5,84.5C 202.167,84.5 193.833,84.5 185.5,84.5C 174.094,66.6957 162.927,48.6957 152,30.5C 141.224,48.391 130.724,66.391 120.5,84.5C 111.833,84.5 103.167,84.5 94.5,84.5C 94.3398,82.8008 94.5065,81.1341 95,79.5C 110.776,52.9422 126.276,26.2755 141.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.955
    },
    fill: "#000000",
    d: "M 256.5,-0.5 C 264.167,-0.5 271.833,-0.5 279.5,-0.5C 279.415,22.8411 279.749,46.1745 280.5,69.5C 300.503,69.3334 320.503,69.5 340.5,70C 343.232,70.3981 345.065,71.8981 346,74.5C 346.498,77.8168 346.665,81.1501 346.5,84.5C 316.833,84.5 287.167,84.5 257.5,84.5C 256.845,56.1714 256.512,27.838 256.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.955
    },
    fill: "#000000",
    d: "M 389.5,-0.5 C 397.167,-0.5 404.833,-0.5 412.5,-0.5C 412.515,22.839 412.848,46.1723 413.5,69.5C 433.503,69.3334 453.503,69.5 473.5,70C 475.848,70.3459 477.681,71.5125 479,73.5C 479.499,77.1516 479.665,80.8183 479.5,84.5C 449.833,84.5 420.167,84.5 390.5,84.5C 389.945,56.1699 389.611,27.8365 389.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.898
    },
    fill: "#212121",
    d: "M 624.5,-0.5 C 635.833,-0.5 647.167,-0.5 658.5,-0.5C 668.331,0.506353 677.165,4.17302 685,10.5C 693.744,22.1662 694.744,34.4995 688,47.5C 682.294,54.1054 675.127,58.2721 666.5,60C 655.485,60.1676 644.485,60.6676 633.5,61.5C 634.465,68.776 634.799,76.1093 634.5,83.5C 631.833,83.5 629.167,83.5 626.5,83.5C 626.009,55.4873 625.342,27.4873 624.5,-0.5 Z M 633.5,6.5 C 641.507,6.33362 649.507,6.50029 657.5,7C 673.167,7.67434 682.167,15.6743 684.5,31C 683.445,43.3901 676.778,50.7234 664.5,53C 654.172,53.4998 643.839,53.6665 633.5,53.5C 633.5,37.8333 633.5,22.1667 633.5,6.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.892
    },
    fill: "#212121",
    d: "M 922.5,-0.5 C 931.5,-0.5 940.5,-0.5 949.5,-0.5C 965.858,4.52379 977.524,14.8571 984.5,30.5C 984.5,38.5 984.5,46.5 984.5,54.5C 977.253,70.1338 965.253,80.1338 948.5,84.5C 940.833,84.5 933.167,84.5 925.5,84.5C 907.258,80.0945 894.758,69.0945 888,51.5C 884.224,31.8892 890.724,16.7225 907.5,6C 912.367,3.22592 917.367,1.05926 922.5,-0.5 Z M 928.5,5.5 C 950.332,3.65851 966.166,12.3252 976,31.5C 980.55,52.2344 973.05,66.7344 953.5,75C 935.761,80.7272 919.761,77.7272 905.5,66C 890.314,48.354 890.98,31.354 907.5,15C 913.848,10.1713 920.848,7.00466 928.5,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.898
    },
    fill: "#212121",
    d: "M 755.5,-0.5 C 766.5,-0.5 777.5,-0.5 788.5,-0.5C 801.599,0.300347 812.099,5.96701 820,16.5C 827.782,41.7309 818.615,56.5642 792.5,61C 800.167,67.3333 807.833,73.6667 815.5,80C 817.141,81.129 818.141,82.629 818.5,84.5C 814.833,84.5 811.167,84.5 807.5,84.5C 796.064,74.905 784.73,65.0717 773.5,55C 780.86,54.6172 788.193,53.9505 795.5,53C 814.015,47.1446 819.182,35.3112 811,17.5C 806.498,12.6635 800.998,9.49681 794.5,8C 784.207,6.73362 773.874,6.23362 763.5,6.5C 764.119,32.1621 764.452,57.8287 764.5,83.5C 761.833,83.5 759.167,83.5 756.5,83.5C 756.357,55.4972 756.024,27.4972 755.5,-0.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpLogo);
export default __webpack_public_path__ + "static/media/tp_logo.54a6c59bdbdf7326292d6c022bde95c5.svg";
export { ForwardRef as ReactComponent };